<div class="container-fluid">
  <div class="row">
    <div class="col">
      <app-title-content-widget [title]="'Find New Vendors'">
        <ng-template #titleContentPanel>
          <div
            class="inner-panel cursor-select"
            (click)="navigateToVendorSearchPage()"
          >
            <div class="row h-100 justify-content-center align-items-center">
              <div class="col">
                <div
                  class="magnifying-glass h-200px background-color-icon-grey"
                ></div>
              </div>
            </div>
          </div>
        </ng-template>
      </app-title-content-widget>
    </div>
  </div>
</div>
